import React from 'react';

import { DispatcherStaffing } from './dispatcher_types';

type DispatcherStaffingSummaryProps = {
  staffing: DispatcherStaffing;
};

const StaffingRow: React.FC<{ label: string; value: number }> = ({ label, value }) => (
  <div>
    {label}: {value}
  </div>
);

export const DispatcherStaffingSummary: React.FC<DispatcherStaffingSummaryProps> = ({ staffing }) => (
  <div className="dispatcher-title">
    <StaffingRow label="Drivers Assigned Shifts" value={staffing.driverShiftCount} />
    <StaffingRow label="Drivers Required" value={staffing.driversRequired} />
    <br />
    <StaffingRow label="Non-Drivers Assigned Shifts" value={staffing.nonDriverShiftCount} />
    <StaffingRow label="Non-Drivers Required" value={staffing.nonDriversRequired} />
  </div>
);
